import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"

class BorderInput extends React.Component {

  constructor(props) {
    super(props);
    this.sides = ['all', 'top', 'right', 'bottom', 'left'];
    this.styles = ['none', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'];
    this.units = ['px', 'pt', 'em'];
    var style = this.props.initialValue || {};
    this.state = {
        activeSide: PageBuilderConstants.ALL,
        style: style
      }
      this._onStyleChange = this._onStyleChange.bind(this);
      this._onSideClick = this._onSideClick.bind(this);
  }

  // sides: ['all', 'top', 'right', 'bottom', 'left'],
  // styles: ['none', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'],
  // units: ['px', 'pt', 'em'],

  componentDidMount() {
    var state = this.parseState(this.state.style[this.getBorderName()]);

    // init color picker plugin
    $(this.refs.colorpicker).spectrum({
      allowEmpty: true,
      preferredFormat: 'rgb',
      cancelText: I18n.t('form_cancel'),
      chooseText: I18n.t('form_submit'),
      showButtons: true,
      showInput: true,
      color: state.color,
      color:  this.props.initialValue,
      hide:   this._onStyleChange,
      move:   this._onStyleChange,
      change: this._onStyleChange
    });
  }

  componentDidUpdate() {
    var state = this.parseState(this.state.style[this.getBorderName()]);
    $(this.refs.colorpicker).spectrum('set', state.color);
  }

  componentWillUnmount() {
    // destroy colorpicker plugin
    $(this.refs.colorpicker).spectrum('destroy');
  }

  componentWillReceiveProps() {
    this.setState({style: this.props.initialValue || {}});
  }

  /**
  * Returns the active CSS border CSS name (e.g. 'border-left')
  *
  * @returns {String}
  */
  getBorderName() {
    return this.state.activeSide == 'all' ? 'border' : 'border-' + this.state.activeSide;
  }

  getColor() {
    var color = $(this.refs.colorpicker).spectrum('get');
    return color ? color.toRgbString() : null;
  }

  // getInitialState: function () {
  //   var style = this.props.initialValue || {};

  //   return {
  //     activeSide: PageBuilderConstants.ALL,
  //     style: style
  //   };
  // },

  parseState(style) {
    var state = {};

    if (style) {
      var splitStyle = style.split(' ');
      state.width = parseFloat(splitStyle[0], 10);
      if (isNaN(state.width)) {
        state.width = 0;
      }
      state.units = splitStyle[0].replace(/[0-9.]*/, '')
      state.style = splitStyle[1]
      state.color = style.replace(/.*(rgb\(.*\).*)/, "$1")
    }

    return state;
  }

  render() {
    var self = this;

    var state = this.parseState(this.state.style[this.getBorderName()]);
    //console.log('parsedState', state);

    return (
      <div className="border-style-widget">
        <div className="sides">{this.renderSides()}</div>
        <div className="inputs">
          <input type="number" className="width" value={state.width} onChange={this._onStyleChange} ref="width" />
          <select className="units" value={state.units} onChange={this._onStyleChange} ref="units">
            {this.renderUnitsOptions()}
          </select>
          <select className="style" value={state.style} onChange={this._onStyleChange} ref="style">
            {this.renderStyleOptions()}
          </select>
          <div className="colorpicker-wrapper"><input type="text" className="colorpicker" ref="colorpicker" /></div>
          <div className="clearfix"></div>
        </div>
        <div className="clearfix"></div>
      </div>
    );
  }

  renderSides() {
    var self = this,
        equalSides = self.equalSides();

    return this.sides.map(function (side) {

      var classes = clsx({
        side: true,
        all: PageBuilderConstants.ALL === side,
        top: PageBuilderConstants.TOP === side,
        right: PageBuilderConstants.RIGHT === side,
        bottom: PageBuilderConstants.BOTTOM === side,
        left: PageBuilderConstants.LEFT === side,
        active: self.state.activeSide === side
      });

      var indicatorStyles = {
        display: (side === PageBuilderConstants.ALL && equalSides) || (!(side === PageBuilderConstants.ALL) && !equalSides) ? 'block' : 'none'
      };

      return (
        <div key={side} className={classes} onClick={self._onSideClick.bind(null, side)}>
          <div className="indicator ss-heavyasterisk" style={indicatorStyles}></div>
        </div>
      );

    });
  }

  renderStyleOptions() {
    return this.styles.map(function (style) {
      return (
        <option value={style} key={style}>{I18n.t(style)}</option>
      )
    });
  }

  renderUnitsOptions() {
    return this.units.map(function (unit) {
      return (
        <option value={unit} key={unit}>{I18n.t(unit)}</option>
      )
    });
  }

  /**
  * Determines if all sides have equal CSS values
  *
  * @returns {Boolean}
  */
  equalSides() {
    var top = this.state.style['border-top'] || null,
        right = this.state.style['border-right'] || null,
        bottom = this.state.style['border-bottom'] || null,
        left = this.state.style['border-left'] || null;

    //console.log('equalSides', top, right, bottom, left)

    return (top == bottom && left == right && top == left && bottom == right);
  }

  _onSideClick(name, event) {
    event.stopPropagation();
    event.preventDefault();

    this.setState({activeSide: name});
    this._onStyleChange();
  }

  _onStyleChange() {
    var name = this.getBorderName();
    var value = $(this.refs.width).val() + $(this.refs.units).val() + ' ' + $(this.refs.style).val() + ' ' + this.getColor();
    var style = this.state.style;

    if (name === 'border') {
      delete style['border-top'];
      delete style['border-right'];
      delete style['border-bottom'];
      delete style['border-left'];
    }

    style[name] = value;
    this.setState({style: style});
    this.forceUpdate();
    this.props.onStyleChange(name, value);
  }

};

export default BorderInput
